import React, { CSSProperties } from 'react';
import { useTheme } from '../../../../hooks/useTheme';
import styles from './IconExpand.module.css';

export interface ExpandIconSvgProps {
  s?: CSSProperties;
}

export interface ExpandIconProps {
  ariaTitle?: string;
  s?: CSSProperties;
  featureName?: string;
}

const ExpandIconSVG = ({ ariaTitle, s }: ExpandIconProps) => (
  <svg
    className={styles.iconExpand}
    style={s}
    fill={s?.color ? s.color : 'currentColor'}
    role={ariaTitle ? 'img' : 'presentation'}
    viewBox="0 0 16 16"
  >
    {ariaTitle && <title>{ariaTitle}</title>}
    <path d="M5.82869 10.1716C5.63343 9.97633 5.31685 9.97633 5.12159 10.1716L1.02539 14.2678L1.02539 11.5C1.02539 11.2239 0.801534 11 0.525392 11C0.249249 11 0.0253906 11.2239 0.025391 11.5L0.0253906 15.4749C0.0253906 15.751 0.249249 15.9749 0.525391 15.9749L4.50023 15.9749C4.77637 15.9749 5.00023 15.751 5.00023 15.4749C5.00023 15.1987 4.77637 14.9749 4.50023 14.9749L1.7325 14.9749L5.82869 10.8787C6.02395 10.6834 6.02395 10.3669 5.82869 10.1716Z" />
    <path d="M10.1713 5.82841C10.3666 6.02367 10.6832 6.02367 10.8784 5.82841L14.9746 1.73221L14.9746 4.49999C14.9746 4.77613 15.1985 4.99999 15.4746 4.99999C15.7508 4.99999 15.9746 4.77613 15.9746 4.49999L15.9746 0.525106C15.9746 0.248964 15.7508 0.0251055 15.4746 0.0251055L11.4998 0.0251083C11.2236 0.0251082 10.9998 0.248967 10.9998 0.525109C10.9998 0.801251 11.2236 1.02511 11.4998 1.02511L14.2675 1.02511L10.1713 5.1213C9.97605 5.31656 9.97605 5.63314 10.1713 5.82841Z" />
  </svg>
);

const ExpandIconThemed = ({ ariaTitle, s }: ExpandIconProps) => {
  const { iconsPrimaryNone } = useTheme();
  return (
    <ExpandIconSVG s={{ ...iconsPrimaryNone, ...s }} ariaTitle={ariaTitle} />
  );
};

const ExpandIcon = ({
  themed = true,
  ...rest
}: ExpandIconProps & { themed?: boolean }) =>
  themed ? <ExpandIconThemed {...rest} /> : <ExpandIconSVG {...rest} />;

export default ExpandIcon;
